export default "__VITE_ASSET__8bcf94fb__"